/// <reference path="DOMAttached.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />
/// <reference path="LegacyHelper.js" />

class GamePopupContainer extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.popup = this.el.querySelector('.outerPopup');
		this.el.attachedObj = this;
	}

	loadPopup(url, onPopupLoaded) {
		this.popup.style.display = 'none';
		this.el.style.display = 'block';

		axios(url, {
			method: 'get'
		}).then(onPopupLoaded);
	}

	showPopup(url) {
		this.loadPopup(url, this.onPopupLoaded.bind(this));
	}

	showContent(content, popupCssClass) {
		if (this.el.closest('.GNOMApplication').querySelector('.animationContainer')) {
			soundManager.stopAll();
			this.el.closest('.GNOMApplication').querySelector('.tabbedApplication').attachedObj.blocked = false;
			this.el.closest('.GNOMApplication').querySelector('.animationContainer').style.display = 'none';
		}
		this.popup.innerHTML = content;
		evalScripts(this.popup);
		this.popup.style.display = 'block';

		if (popupCssClass) {
			this.popup.classList.add(popupCssClass);
			if (popupCssClass === 'playAction') {
				var playActionPopup = this.popup;
				setTimeout(function() {
					playActionPopup.style.display = 'none';
					playActionPopup.classList.remove('playAction');
				}, 5000);
			}
		}

		// Give Focus to first input control
		var inputEl = this.el.querySelector('input[type="text"]');
		if (inputEl != null) {
			inputEl.focus();
		}
	}

	hidePopup() {
		this.el.style.display = 'none';
	}

	isPopupVisible() {
		return (this.el.style.display == 'block');
	}

	onPopupLoaded(req) {
		this.popup.style.display = 'none';
		this.el.style.display = 'block';

		var json = req.data;

		if (json.success) {
			this.showContent(json.popup, json.popupCssClass);
		} else {
			//Does it come with a message popup?
			if (json.errorpopup != undefined) {
				this.showContent(json.errorpopup);
				return;
			}

			this.hidePopup();
		}
	}
}
